import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complete-create-account',
  templateUrl: './complete-create-account.component.html',
  styleUrls: ['./complete-create-account.component.scss']
})
export class CompleteCreateAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
